import { LogManager } from '../../../../common/port/log/log.manager.port';
import { CategoryMetricsAverageWholeTeamParentAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/category/category-metrics-average-whole-team-parent.aggregate-root.mapper';
import { GetCategoryMetricsAverageWholeTeamRequestDto } from '../../../dtos/team-metrics/category/get-category-metrics-average-whole-team.request.dto';
import { GetCategoryMetricsTotalsResponseDto } from '../../../dtos/team-metrics/category/get-category-metrics-totals.response.dto';
import { GetCategoryMetricsAverageWholeTeamQuery } from '../../../queries/team-metrics/category/get-category-metrics-average-whole-team.query';

export class GetCategoryMetricsAverageWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetCategoryMetricsAverageWholeTeamQuery,
    protected readonly mapper: CategoryMetricsAverageWholeTeamParentAggregateRootMapper
  ) {}

  async get(
    props: GetCategoryMetricsAverageWholeTeamRequestDto
  ): Promise<GetCategoryMetricsTotalsResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `CategoryMetricsAverageWholeTeamComponentController.get encountered an error ${error}`
      );
    }
  }
}
